(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('HistoricoAfericoesSemeaduraCtrl', HistoricoAfericoesSemeadura);

  HistoricoAfericoesSemeadura.$inject = [
    'MaquinasService',
    'AtividadesService',
    '$q',
    'MessagesService',
    '$rootScope',
    'LoadingService',
    'SemeaduraAfericaoService',
    '$scope',
    '$templateCache',
    'OperacoesDadosService',
    '$routeParams'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function HistoricoAfericoesSemeadura(MaquinasService, AtividadesService, $q,
    MessagesService, $rootScope, LoadingService, SemeaduraAfericaoService, $scope,
    $templateCache, OperacoesDadosService, $routeParams) {
    const vm = this;
    let hasPage = true;
    let inProgress = false;

    // Controller data
    vm.filters = {
      safra: null,
      gleba: null,
      implemento: null,
      atividade: null,
      page: 1,
      tipo: 'semente'
    };
    vm.atividades = [];
    vm.maquinas = [];
    vm.afericoes = [];
    vm.loadingAfericoes = false;
    vm.initialized = false;

    // Bindable methods
    vm.setFilterAttribute = setFilterAttribute;
    vm.list = list;
    vm.selectAfericao = selectAfericao;

    // Function declarations
    function filtersData() {
      const promises = [
        MaquinasService.list(),
        AtividadesService.list()
      ];

      return $q.all(promises)
        .then(([maquinas, atividades]) => {
          vm.maquinas = maquinas.data || [];
          vm.atividades = atividades.data || [];
        })
        .catch((error) => {
          console.error(error);
          MessagesService.alert('Erro ao carregar dados dos filtros, tente novamente.');
        });
    }

    function initializeVariables() {
      deactivateAfericoes();
      hasPage = true;
      inProgress = false;
      vm.afericoes = [];
      vm.filters.page = 1;
    }

    function list() {
      const hasFilterPage = hasPage && vm.filters && vm.filters.page;
      if (hasFilterPage && !inProgress) {
        LoadingService.showLoading();
        inProgress = true;
        vm.loadingAfericoes = true;

        return SemeaduraAfericaoService.summarized(vm.filters)
          .then(({ data, pages }) => {
            hasPage = _.get(pages, 'pagination.next', 0) > vm.filters.page;
            if (data.length) {
              vm.filters.page++;
              vm.afericoes = vm.afericoes.concat(data);
            }
          })
          .catch((error) => {
            console.error('Falha ao buscar dados de semeadura aferição!', error);
            MessagesService.alert('Falha ao buscar dados de semeadura aferição!');
          })
          .finally(() => {
            inProgress = false;
            vm.loadingAfericoes = false;
            LoadingService.hideLoading();
          });
      }
      return $q.resolve();
    }

    function setFilterAttribute(attribute, object, event) {
      if (event) {
        event.preventDefault();
      }
      initializeVariables();
      vm.filters[attribute] = object;
      list();
    }

    function deactivateAfericoes(selected = null) {
      vm.afericoes
        .filter((afericao) => afericao !== selected)
        .forEach((afericao) => {
          afericao.selected = false;
        });
      $scope.$emit('clearMarkers');
    }

    function selectAfericao(selected) {
      selected.selected = !selected.selected;

      deactivateAfericoes(selected);

      if (selected.selected) {
        if (!selected.markers) {
          const template = $templateCache.get('views/infowindow_templates/infowindowoperations.tpl.html');
          LoadingService.showLoading();
          return loadMarkers(selected)
            .then((data) => {
              selected.markers = OperacoesDadosService.newGetMarkersOperationsDayGleba(data, null, template);
              $scope.$emit('setMarkers', selected.markers);
              $scope.$emit('setFocusedGleba', selected.cd_gleba);
            })
            .catch((error) => {
              console.error(error);
              MessagesService.alert('Não foi possível carregar os pontos da aferição selecionada.');
              selected.selected = false;
            })
            .finally(LoadingService.hideLoading);
        }
        $scope.$emit('setFocusedGleba', selected.cd_gleba);
        return $scope.$emit('setMarkers', selected.markers);
      }
      $scope.$emit('setFocusedGleba', null);
      $scope.$emit('clearMarkers');
    }

    function loadMarkers(afericao) {
      return SemeaduraAfericaoService.list({
        implemento: afericao.implemento_id,
        gleba: afericao.cd_gleba,
        safra: _.get(vm.filters.safra, 'id', null),
        tipo: vm.filters.tipo,
        tipo_medida_semeadura: afericao.tipo_medida,
        tarefa_id: afericao.tarefa_id
      })
        .then(({ data }) => data);
    }

    // Controller logic
    LoadingService.showLoading();
    initializeVariables();

    const initListener = $scope.$watch('wrap.activeTab', (value) => {
      if (value === 'semeadura_afericao') {
        $rootScope.initialize
          .then(() => $q.all([filtersData(), list()]))
          .finally(() => {
            vm.initialized = true;
            LoadingService.hideLoading();
            initListener();
          });
      }
    });

    $scope.$on('$routeUpdate', () => {
      if ($routeParams.activeTab !== 'semeadura_afericao') {
        deactivateAfericoes();
      }
    });

    $scope.$on('$destroy', () => {
      $scope.$emit('setFocusedGleba', null);
      $scope.$emit('clearMarkers');
    });
  }
}());
